<script setup lang="ts">

import type { Praeparat } from '@/types/otc/praeparat'
import {computed, toRef} from "vue";
import {useProductImage} from "@/vue_components/praeparate/composables/useProductImage";

interface Props {
  praeparat: Praeparat | null
  width?: number
  quality?: number
  transparent?: boolean
  useBgColor?: boolean
  showCaption?: boolean
  caption?: string
  cssClass?: string
  altText?: string
}

const props = withDefaults(defineProps<Props>(), {
  width: 405,
  quality: 100,
  transparent: false,
  useBgColor: false,
  showCaption: false,
  caption: '',
  cssClass: '',
  altText: ''
})

const praeparatRef = toRef(props, 'praeparat')
const { bgColor, buildImageUrl } = useProductImage(praeparatRef)

const imageUrl = computed(() => {
  const backgroundColor = props.useBgColor ? props.praeparat?.otcKategorie?.farbe : undefined
  return buildImageUrl(props.width, props.quality, props.transparent, backgroundColor)
})

const categoryClass = computed(() => props.praeparat?.otcKategorie?.id || '')
const imageAlt = computed(() => props.altText || props.praeparat?.name || '')

</script>

<template>
  <div :class="[categoryClass, cssClass]">
    <img
        class="img-fluid"
        :src="imageUrl"
        :alt="imageAlt"
    />
    <figcaption v-if="showCaption && caption">
      {{ caption }}
    </figcaption>
  </div>
</template>

<style scoped>

</style>